<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';
import HistoryItemInfoModal from '@/components/loans/InfoModal';

export default {
    page: {
        title: 'Loans'
    },

    components: {
        HistoryItemInfoModal
    },

    extends: TableView,

    data() {
        const { status = null } = this.$route.query;

        return {
            pageTitle: 'Loan History',
            includeDeleteAction: false,
            mainClass: 'loans-table',
            selectedItem: null,
            activeTab: {
                value: status
            }
        };
    },

    computed: {
        ...mapGetters({
            ACTIVE_STATUS: 'loans/ACTIVE',
            ENDED_STATUS: 'loans/ENDED',
            ALL_STATUSES: 'loans/ALL_STATUSES'
        }),

        labels() {
            const labels = [
                {
                    value: 'user.fullName',
                    width: '200px',
                    sortFieldName: 'user.firstName'
                },
                {
                    value: 'product.name',
                    width: '200px'
                },
                {
                    value: 'number',
                    type: 'number',
                    width: '130px'
                },
                {
                    value: 'startDate',
                    type: 'date',
                    width: '150px'
                },
                {
                    value: 'endDate',
                    type: 'date',
                    width: '150px'
                },
                {
                    width: '200px',
                    text: 'Campus',
                    sortable: false,
                    value: 'product.loanShop.campuses',
                    filterFieldName: 'product.loanShop.campuses.name',
                    filter: 'joinTable'
                },

                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];

            const { value: status } = this.activeTab;

            if (status && status !== this.ENDED_STATUS) {
                return labels;
            }

            if (!status) {
                labels.unshift({
                    value: 'status',
                    width: '150px',
                    type: 'enum',
                    enumOptions: this.ALL_STATUSES.map(item => item.value)
                });
            }

            return [
                ...labels,
                {
                    value: 'returnedAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        },

        options() {
            const options = {
                addButton: false,
                searchInput: false
            };

            if (this.activeTab.value) {
                options.linkSuffix = `&status=${this.activeTab.value}`;
            }

            return options;
        },

        additionalComponents() {
            if (!this.selectedItem) {
                return [];
            }

            return [
                {
                    name: 'history-item-info-modal',
                    props: {
                        item: this.selectedItem
                    },
                    events: {
                        'item-updated': this.onItemUpdated
                    }
                }
            ];
        },

        tabsElements() {
            return [{ value: null, text: 'All' }, ...this.ALL_STATUSES];
        },

        additionalFetchData() {
            return {
                status: this.activeTab.value
            };
        }
    },

    watch: {
        activeTab() {
            this.pagination.currentPage = 1;
            this.pagination.sortBy = 'createdAt';

            this.tableKey += 1;

            this.fetchItems();
        }
    },

    methods: {
        ...mapActions({
            getItems: 'loans/index',
            deleteItem: 'loans/destroy'
        }),

        async onRowClick(item) {
            this.selectedItem = { ...item };

            await this.$nextTick();

            this.$bvModal.show('loan-info-modal');
        },

        getRowClass({ endDate, status }) {
            if (this.activeTab.value) {
                return '';
            }

            if (
                status === this.ACTIVE_STATUS &&
                this.$dayjs().isSameOrAfter(endDate)
            ) {
                return 'overdue-item';
            }

            return `${status}-item`;
        },

        onItemUpdated(loan) {
            const index = this.items.findIndex(item => item.id === loan.id);

            if (~index) {
                this.items.splice(index, 1, loan);
            }
        }
    }
};
</script>
